// src/utils/googleAds.js
// Profinoks - Google Ads Özel Etkinlik ve Dönüşüm Takipçisi

export const GOOGLE_ADS_ID = 'AW-1581767221';

// Google Ads panelinde tanımlayacağınız dönüşüm etiketlerini (Conversion Label) buraya ekleyebilirsiniz.
// Panelden etiket aldığınızda ilgili alanı doldurmanız yeterlidir (örn: 'AbCdEfGhIjKlMnOpQr').
export const CONVERSION_LABELS = {
  WHATSAPP_CLICK: '',
  PHONE_CALL_CLICK: '',
  QUOTE_SUBMIT: '',
  CONTACT_SUBMIT: '',
};

/**
 * Google Ads Dönüşüm ve Olay Takip Fonksiyonu
 * @param {string} actionName - 'whatsapp_click' | 'phone_call_click' | 'quote_request_submit' | 'contact_form_submit' vb.
 * @param {object} [details] - Ek parametreler (örn: value, currency)
 * @param {string} [customLabel] - Varsa özel dönüşüm etiketi
 */
export const trackGoogleAdsConversion = (actionName, details = {}, customLabel = '') => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    const labelKey = actionName.toUpperCase().replace(/-/g, '_');
    const label = customLabel || CONVERSION_LABELS[labelKey] || '';

    // Eğer Google Ads panelinden dönüşüm etiketi girilmişse onunla, yoksa doğrudan Ads ID ile gönderir
    const sendTo = label ? `${GOOGLE_ADS_ID}/${label}` : GOOGLE_ADS_ID;

    // 1. Google Ads Conversion Sinyali
    window.gtag('event', 'conversion', {
      send_to: sendTo,
      event_category: 'B2B_Lead',
      event_label: actionName,
      ...details
    });

    // 2. Genel Etkinlik (Custom Event)
    window.gtag('event', actionName, {
      event_category: 'B2B_Lead',
      event_label: actionName,
      ...details
    });

    console.log(`[Google Ads] Dönüşüm kaydedildi: ${actionName}`, { send_to: sendTo, details });
  } else {
    console.warn('[Google Ads] window.gtag bulunamadı. Etiket henüz yüklenmemiş olabilir.');
  }
};
